import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "q-px-sm" };
const _hoisted_3 = {
    key: 1,
    class: "row q-gutter-xs padding-none st-ht-300"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_tab = _resolveComponent("q-tab");
    const _component_q_tabs = _resolveComponent("q-tabs");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_scroll_area = _resolveComponent("q-scroll-area");
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    const _component_q_tab_panel = _resolveComponent("q-tab-panel");
    const _component_q_tab_panels = _resolveComponent("q-tab-panels");
    const _component_q_card = _resolveComponent("q-card");
    return (_openBlock(), _createBlock(_component_q_card, { class: "full-width" }, {
        default: _withCtx(() => [
            _createVNode(_component_q_tabs, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.tab) = $event)),
                align: "left",
                class: "text-grey-6 shadow-2 grey3-dark-variant-background",
                dense: ""
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (value, index) => {
                        return (_openBlock(), _createBlock(_component_q_tab, {
                            name: value.name,
                            icon: value.icon,
                            key: `category${index}`
                        }, null, 8, ["name", "icon"]));
                    }), 128))
                ]),
                _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_tab_panels, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.tab) = $event)),
                animated: "",
                onBeforeTransition: _ctx.queryEmoji
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (value, index) => {
                        return (_openBlock(), _createBlock(_component_q_tab_panel, {
                            name: value.name,
                            class: "q-pa-sm",
                            key: `emoji${index}`
                        }, {
                            default: _withCtx(() => [
                                (_ctx.emojiList[value.name])
                                    ? (_openBlock(), _createBlock(_component_q_scroll_area, {
                                        key: 0,
                                        class: "row q-gutter-xs padding-none st-ht-300",
                                        "thumb-style": _ctx.thumbStyle
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiList[value.name], (expression, icon_ind) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: icon_ind,
                                                    class: "cursor-pointer icon-sm",
                                                    onClick: ($event) => (_ctx.addEmoji(expression.char))
                                                }, [
                                                    _createElementVNode("span", _hoisted_2, _toDisplayString(expression.char), 1)
                                                ], 8, _hoisted_1));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1032, ["thumb-style"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(_component_q_inner_loading, {
                                            color: "accent",
                                            showing: ""
                                        })
                                    ]))
                            ]),
                            _: 2
                        }, 1032, ["name"]));
                    }), 128))
                ]),
                _: 1
            }, 8, ["modelValue", "onBeforeTransition"])
        ]),
        _: 1
    }));
}
